
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";
import ConditionsUtilisation from "../pages/conditions-utilisation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/conditions-utilisation",
    element: <ConditionsUtilisation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
